export default "__VITE_PUBLIC_ASSET__4fd28842__"